const isBrowser = (): boolean => {
  return (typeof window !== 'undefined');
};

export const stringToBase64 = (s: string): string => {
  let ret: string;

  if(isBrowser())
  {
    ret = btoa(unescape(encodeURIComponent(s)));
  }
  else
  {
    ret = Buffer.from(unescape(encodeURIComponent(s)), 'latin1').toString('base64');
  }

  return ret;
};

export const base64ToString = (b: string): string => {
  let ret: string;

  if(isBrowser())
  {
    ret = decodeURIComponent(escape(atob(b)));
  }
  else
  {
    ret = decodeURIComponent(escape(Buffer.from(b, 'base64').toString('latin1')));
  }

  return ret;
};
